// Выборка блока «Рекомендуемые» на /tutors (02.11.2026). Без серверных
// импортов: модуль читают страница и scripts/verify-map-featured.mts.

/** Карточек в блоке. Сервер рисует 4; на телефоне 4-я скрыта CSS и стоит в списке. */
export const FEATURED_MAX = 4;
/** Видно на телефоне (≤ 880 px, как NARROW_QUERY): первые 3. */
export const FEATURED_NARROW = 3;

/**
 * Из списка, уже прошедшего фильтры и вкладку, — анкеты с рангом (то есть
 * рекомендуемые), по возрастанию ранга, не больше max. Ранг — место в
 * случайном порядке, который решил сервер: одинаково в SSR и в браузере.
 */
export function pickFeatured<T extends { p: { id: string } }>(list: readonly T[], rank: ReadonlyMap<string, number>, max: number): T[] {
  if (!rank.size) return [];
  return list.filter((x) => rank.has(x.p.id)).sort((a, b) => rank.get(a.p.id)! - rank.get(b.p.id)!).slice(0, max);
}
